import { FileRepository } from '@src/main/shared/domain/file.repository';

export const downloadFileUseCase = async (
  keyFile: string,
  fileName: string,
  repository: FileRepository,
): Promise<void> => {
  await repository.download(keyFile, fileName);
};
export const downloadImageUseCase = async (
  keyFile: string,
  fileName: string,
  repository: FileRepository,
): Promise<void> => {
  await repository.downloadImage(keyFile, fileName);
};
export const getImageUrlFileUseCase = async (
  keyFile: string,
  fileName: string,
  repository: FileRepository,
): Promise<string> => await repository.getImageUrl(keyFile, fileName);
